import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskServiceModalEditRoute } from '@atlassian/jira-router-routes-servicedesk-services-routes/src/servicedeskServiceModalEditRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import ServiceUpdateModalWithoutProjectContext, {
	LazyServiceUpdateModalWithProjectContext,
} from './ui/service-update-modal-without-project-context/index.tsx';

export const servicedeskServiceModalEditRouteEntry = createEntry(
	servicedeskServiceModalEditRoute,
	() => ({
		group: 'servicedesk',
		component: ServiceUpdateModalWithoutProjectContext,
		layout: serviceProjectLayout,
		resources: [...getServiceDeskNavigationResources(), ...getServicedeskPageContextResources()],
		forPaint: [LazyAtlassianNavigation, LazyServiceUpdateModalWithProjectContext],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-services-entries/src/servicedeskServiceModalEditRouteEntry.tsx',
				whichExportToUse: 'servicedeskServiceModalEditRouteEntry',
			},

			enabled: true,
		},
	}),
);
